export const PlusIcon = () => (
  <i className="ki-solid ki-plus text-white text-md" />
);
